import { TargetGroup } from '../components/SkillsTable/SkillsTable';

export interface StandardGrade {
  id: string;
  name: string;
  targetGroups: TargetGroup[];
}

export const groupTargetGroupsByStandardGrade = (targetGroups: TargetGroup[] | [] = []): StandardGrade[] => {
  const grouped = Object.values(
    targetGroups.reduce(
      (acc, roadmap) => {
        if (!roadmap.standardGrade) {
          return acc;
        }
        const gradeId = roadmap.standardGrade.id;
        if (!acc[gradeId]) {
          acc[gradeId] = {
            id: roadmap.standardGrade.id,
            name: roadmap.standardGrade.name ?? '',
            targetGroups: [],
          };
        }

        acc[gradeId].targetGroups.push({
          id: roadmap.id,
          name: roadmap.name ?? '',
        });

        return acc;
      },
      {} as Record<string, { id: string; name: string; targetGroups: { id: string; name: string }[] }>,
    ),
  );

  return grouped.length > 0 ? grouped : [];
};
